import { useState, useEffect, useRef } from "react";

import { Volume2, VolumeOff } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Home, Eye, Heart } from "lucide-react";
import omimage from "../assets/images/omimage.png";
import storiesimg from "../assets/images/storiesimg.jpg";
import bannerImg from "../assets/images/storybanner.webp";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/mousewheel";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Autoplay } from "swiper/modules";
import new_defaultimg from '../assets/images/new_omsaga_default.png';

const AllStory = () => {
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const dispatch = useDispatch(); 
  const navigate = useNavigate();

  const [isDisabled, setIsDisabled] = useState(false);
  const [storiesarr, setstoriesarr] = useState([]);
  const [showpageloading, setshowpageloading] = useState(false);
  const [forcestate, setforcestate] = useState(false);
  const storiesarrRef = useRef();
  storiesarrRef.current = storiesarr;
  const audioRef = useRef(null);
      const [playing, setPlaying] = useState(false);

      const handleplayaudio = (name) => {
        // var url = '/storage/uploads/audio/'+name;
        var url = assetsUrl + "/audio/" + name
        console.log('url >>', url)
        if (!audioRef.current) {
          audioRef.current = new Audio(url);
        }
        audioRef.current.play();
        setPlaying(true);
      }
  
      const handleStop = () => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          setPlaying(false);
        }
      };


  const handlechangestatus = async (id, status, index) => {
    var currentstatus = status;
    if(currentstatus == true || currentstatus == "true") {
      var newstatus = "false";
    } else {
      var newstatus = "true";
    }
    var prevarr = storiesarrRef.current;
    prevarr[index].status = newstatus;
    setstoriesarr(prevarr);
    setforcestate(!forcestate);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + customerdata?.token,
      },
    };
    var data = {
      id: id,
      status: newstatus
    }
    let resp = await axios
      .post(apiUrl + "changemystorystatus",data, headers)
      .then((res) => {
        if (res.data.status == "success") {
        } else {
        }
      })
      .catch((err) => {
        console.log("err >>", err);
      });
  }

  const fetchstorydetails = async () => {
    setshowpageloading(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + customerdata?.token,
      },
    };
    let resp = await axios
      .get(apiUrl + "getallmystories", headers)
      .then((res) => {
        if (res.data.status == "success") {
          setstoriesarr(res.data.data);
          setshowpageloading(false);
        } else {
          setstoriesarr([]);
          setshowpageloading(false);
        }
        setshowpageloading(false);
      })
      .catch((err) => {
        console.log("err >>", err);
        setshowpageloading(false);
      });
  };

  useEffect(() => {
    fetchstorydetails();
  }, [])




  return (
    <div>
      <section className="home-main-sec ">
        <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">
          <h1 className="loop-title">
            A collection of real spiritual experiences
          </h1>
        </div>
      </section>

      <section className="home-stories-main-section">
        <div className="container text-center">
          <img src={omimage} className="om-image-stories" alt="om" />

          <span className="home-subhead">Stories</span>
          <p className="home-heading">My Stories</p>
          <div className="home-heading-divider"></div>

          {
            storiesarr?.length > 0 ?
            <Swiper
              spaceBetween={20}
              grabCursor={true}
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              style={{ paddingBottom: "20px" }}
              breakpoints={{
                0: {
                  slidesPerView: 1,   // mobile
                },
                768: {
                  slidesPerView: 2,   // tablet & desktop
                },
              }}
            >
            {/* Slide 1 */}
            {
              storiesarr?.length > 0 ?
              storiesarr?.map((item, index) => {
                let reloadimg = "";
                if (item?.photos) {
                  const arr = JSON.parse(item?.photos);
                  if (arr?.length > 0) reloadimg = arr[0];
                }
                return (
                  <SwiperSlide className="home-story-slide">
                    <div
                      className={`home-story-card ${
                        item?.status == "false" || item?.status == false
                          ? "story-disabled"
                          : ""
                      }`}
                    >
                      <img
                        src={
                          reloadimg
                            ? assetsUrl + "/photos/" + reloadimg
                            : new_defaultimg
                        }
                        className="home-story-card-img"
                        alt=""
                      />
                      <div className="home-story-overlay"></div>

                      {
                item?.audio ?
                null :
                <div className="home-story-category">• Story</div>
              }

                      <div className="home-story-content">
                        <p className="home-story-title">{item?.title}</p>

                        <div className="home-meta-row">
                          <div className="home-meta-item">
                            <Heart size={14} />
                            <span>{item?.liked || 0}</span>
                          </div>
                          <div className="home-meta-item">
                            <Eye size={14} />
                            <span>{item?.view || 0}</span>
                          </div>
                        </div>

                        {/* Action Row */}
                        <div className="home-story-actions">
                          <span
                            className="home-story-readmore"
                            onClick={() => {
                              window.open(`/story/${item?.slug}`, "_blank");
                              // navigate("/story/" + item?.slug)
                            }}
                          >
                            View
                          </span>

                          <span
                            className="home-story-edit"
                            onClick={() =>
                              navigate("/edit-story/" + item?.slug)
                            }
                          >
                            Edit Story
                          </span>

                          <span
                            className="home-story-disable"
                            onClick={() => {
                              handlechangestatus(item?.id, item?.status, index);
                            }}
                          >
                            {item?.status == "false" || item?.status == false
                              ? "Enable"
                              : "Disable"}
                          </span>
                        </div>
                      </div>

                      {/* {
                          item?.audio ?
                          <div className="home-story-audio">
                        <Volume2 size={20} />
                      </div> : null
                        } */}
                      {item?.audio && (
                        <div className="home-story-audio">
                          {playing ? (
                            <VolumeOff
                              size={20}
                              onClick={() => handleStop(item?.audio)}
                            />
                          ) : (
                            <Volume2
                              size={20}
                              onClick={() => handleplayaudio(item?.audio)}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                );
              }) : null
            }
            

            {/* Slide 2 (duplicate UI) */}
            {/* <SwiperSlide className="home-story-slide">
        <div className="home-story-card">
          <img src={storiesimg} className="home-story-card-img" alt="story" />
          <div className="home-story-overlay"></div>
          <div className="home-story-category">• Story</div>
          <div className="home-story-content">
            <p className="home-story-title">Inner Peace</p>
            <div className="home-meta-row">
              <div className="home-meta-item">
                <Heart size={14} />
                <span>98</span>
              </div>
              <div className="home-meta-item">
                <Eye size={14} />
                <span>410</span>
              </div>
            </div>
            <p className="home-story-readmore">Read More</p>
          </div>
          <div className="home-story-audio">
            <Volume2 size={20} />
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide className="home-story-slide">
        <div className="home-story-card">
          <img src={storiesimg} className="home-story-card-img" alt="story" />
          <div className="home-story-overlay"></div>
          <div className="home-story-category">• Story</div>
          <div className="home-story-content">
            <p className="home-story-title">Inner Peace</p>
            <div className="home-meta-row">
              <div className="home-meta-item">
                <Heart size={14} />
                <span>98</span>
              </div>
              <div className="home-meta-item">
                <Eye size={14} />
                <span>410</span>
              </div>
            </div>
            <p className="home-story-readmore">Read More</p>
          </div>
          <div className="home-story-audio">
            <Volume2 size={20} />
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide className="home-story-slide">
        <div className="home-story-card">
          <img src={storiesimg} className="home-story-card-img" alt="story" />
          <div className="home-story-overlay"></div>
          <div className="home-story-category">• Story</div>
          <div className="home-story-content">
            <p className="home-story-title">Inner Peace</p>
            <div className="home-meta-row">
              <div className="home-meta-item">
                <Heart size={14} />
                <span>98</span>
              </div>
              <div className="home-meta-item">
                <Eye size={14} />
                <span>410</span>
              </div>
            </div>
            <p className="home-story-readmore">Read More</p>
          </div>
          <div className="home-story-audio">
            <Volume2 size={20} />
          </div>
        </div>
      </SwiperSlide> */}
          </Swiper> :
          <div className="nostoryadded">
             <p>No stories added.</p>
          </div>
         
          }

         
        </div>
      </section>
    </div>
  );
};
export default AllStory;
